// Effects
import { all, put, takeLatest } from 'redux-saga/effects';

// Constants
import {
  GET_SELF_EVALUATION_LIST,
  GET_SELF_EVALUATION_LIST_SUCCESS,
  GET_SELF_EVALUATION_LIST_FAILURE,
} from '../../modules/constants';

// Service
import { defaultApi } from '../../utils/axiosApi';

export function* selfEvaluationListRequest({ payload }) {
  try {
    const url = `albait/employee-evaluation/`;
    let method = 'POST';

    // if payload has null values, remove them
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, value]) => value !== null)
    );

    // add mashaer dates
    filteredPayload.mashaer_dates = ["2025-06-04", "2025-06-05", "2025-06-06", "2025-06-07", "2025-06-08"];

    // Use the filtered payload in the POST request
    const requestPayload = {
      ...filteredPayload,
    };

    const response = yield defaultApi(url, method, requestPayload);
    yield put({
      type: GET_SELF_EVALUATION_LIST_SUCCESS,
      payload: { data: response },
    });
  } catch (err) {
    yield put({
      type: GET_SELF_EVALUATION_LIST_FAILURE,
      payload: err,
    });
  }
}

export default function* root() {
  yield all([
    takeLatest(GET_SELF_EVALUATION_LIST, selfEvaluationListRequest),
  ]);
}